import { ReactNode, useEffect } from "react";
import { initCloudWatchRumClient } from "../../config/cloudWatchRum";

interface CloudwatchRumWrapperProps {
  children: ReactNode;
}

const CloudwatchRumWrapper = (props: CloudwatchRumWrapperProps) => {
  useEffect(() => {
    initCloudWatchRumClient();
  }, []);

  return <>{props.children}</>;
};

export default CloudwatchRumWrapper;
